import Text from '$tablet-app/src/app/components/Text';
import { useSignOut } from '@akin-home/auth/react';
import { useHasLockPIN } from '@akin-home/lock-screen/react';
import {
  DrawerContentComponentProps,
  DrawerContentScrollView,
  DrawerItem,
  DrawerItemList,
} from '@react-navigation/drawer';

import { Button } from '@akin-home/buttons/native';
import { isAndroidBuild } from '@akin-home/utils/native';
import React, { useState } from 'react';
import { SafeAreaView, StyleSheet, View } from 'react-native';
import { Overlay } from 'react-native-elements';
import { drawerIcon } from '../../../components/DrawerIcon/DrawerIcon';
import { removeUserCredentials } from '../../../credentialStorage';
import { useStateStore } from '../../../stores/useStateStore';
import { palette, spacing } from '../../../theme';
import { useCurrentUserID } from '../../../users';
import { openMainSystemSettings } from '../../functions';

const SettingsDrawerContent = (props: DrawerContentComponentProps) => {
  const user_id = useCurrentUserID();

  const { data: has_pin } = useHasLockPIN({ user_id });
  const lockApp = useStateStore((state) => state.lockApp);
  const onPressLockApp = () => lockApp(user_id);

  const [visible, setVisible] = useState(false);
  const toggleLogoutOverlay = () => {
    setVisible(!visible);
  };

  const signOut = useSignOut();
  async function onPressSignOut() {
    try {
      await signOut();
      removeUserCredentials();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  return (
    <SafeAreaView style={styles.drawerContainer}>
      <DrawerContentScrollView {...props}>
        <DrawerItemList {...props} />
      </DrawerContentScrollView>

      <View>
        {isAndroidBuild() ? (
          <DrawerItem
            icon={drawerIcon('tablet')}
            style={styles.drawerItemContainer}
            label="Device Settings"
            labelStyle={styles.drawerItemLabel}
            onPress={openMainSystemSettings}
          />
        ) : null}

        {has_pin ? (
          <DrawerItem
            icon={drawerIcon('lock')}
            style={styles.drawerItemContainer}
            label="Lock App"
            labelStyle={styles.drawerItemLabel}
            onPress={onPressLockApp}
          />
        ) : null}

        <DrawerItem
          icon={drawerIcon('sign-out')}
          style={styles.drawerItemContainer}
          label="Sign out"
          labelStyle={styles.drawerItemLabel}
          onPress={toggleLogoutOverlay}
        />
      </View>

      {/* Sign Out Overlay */}
      <Overlay
        overlayStyle={styles.logoutOverlay}
        isVisible={visible}
        onBackdropPress={toggleLogoutOverlay}
      >
        <View style={styles.logoutContainer}>
          <Text style={styles.logoutTitle}>Sign out</Text>
          <Text style={styles.logoutBody}>
            Are you sure you want to sign out?
          </Text>
          <Button
            style={styles.logoutButton}
            textStyle={styles.logoutText}
            variant="primary"
            onPress={onPressSignOut}
          >
            Sign out
          </Button>
          <Button
            style={styles.cancelButton}
            textStyle={styles.logoutText}
            variant="secondary"
            onPress={toggleLogoutOverlay}
          >
            Cancel
          </Button>
        </View>
      </Overlay>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  drawerContainer: {
    flex: 1,
  },
  drawerItemContainer: {
    justifyContent: 'flex-start',
  },
  drawerItemLabel: {
    fontSize: 20,
    fontWeight: 'bold',
  },

  logoutBody: {
    color: palette.black,
    fontSize: 18,
    fontWeight: 'normal',
    marginTop: 40,
    textAlign: 'center',
  },
  logoutButton: {
    justifyContent: 'center',
    marginTop: 60,
    width: '100%',
  },
  logoutContainer: {
    flex: 1,
    width: 300,
  },
  logoutOverlay: {
    alignItems: 'stretch',
    borderRadius: 20,
    flexDirection: 'row',
    height: 400,
    justifyContent: 'space-between',
    padding: 30,
    width: 400,
  },
  logoutText: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  logoutTitle: {
    color: palette.black,
    fontSize: 24,
    fontWeight: 'bold',
    marginTop: 40,
    textAlign: 'center',
  },
  cancelButton: {
    justifyContent: 'center',
    marginTop: spacing[2],
    width: '100%',
  },
});

export default SettingsDrawerContent;
